import { useContext, useState } from "react";

import Axios from "axios";
import { Button, Col, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";

import InputControl from "../../../components/inputs/InputControl";
import InputFarsi from "../../../components/inputs/InputFarsi";
import InputNumber from "../../../components/inputs/InputNumber";
import Mobile from "../../../components/inputs/Mobile";
import Switchrs from "../../../components/inputs/Switchrs";
import DashboardContext from "../../../Context";
import Mobilecheckexist from "../../../components/inputs/Mobilecheckexist";

export default function ModalAddCoustmer({ show, handleClose, setiduserCrate, setUsemobileCreate }) {

    const { authentication, urldashboard, handelerrors } = useContext(DashboardContext);

    const [formdata, setFormdata] = useState({ roleIds: ["829bb04d-96b3-e811-80bc-0cc47aa87eb2"], isActive: false })

    const [dataUpdate, setDataUpdate] = useState({})

    const [LoadingForm, setLoadingForm] = useState(false)

    const [statuseMobile, setStatuseMobile] = useState(false)

    const [iduserExist, setIduserExist] = useState('')



    const handelValue = (name, value) => {
        switch (name) {
            case 'referrerId':
                setFormdata({ ...formdata, referrerId: value })
                break;
            case 'userName':
                setFormdata({ ...formdata, userName: value })
                break;
            case 'lastName':
                setFormdata({ ...formdata, lastName: value })
                break;
            case 'firstName':
                setFormdata({ ...formdata, firstName: value })
                break;
            case 'nationalCode':
                setFormdata({ ...formdata, nationalCode: value === "" ? null : value })
                break;
            case 'tell':
                setFormdata({ ...formdata, tell: value })

                break;
            case 'roleIds':
                setFormdata({ ...formdata, roleIds: value })
                break;
            case "isActiveFormUser":
                setFormdata({ ...formdata, isActive: value });
                break;
            case "description":
                setFormdata({ ...formdata, description: value });
                break;
            default:
                break;
        }
    }


    const handelSend = async () => {
        try {
            const res = await Axios.post(`${urldashboard}/userManagement/create`, JSON.stringify(formdata), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json; charset=utf-8 "
                }
            })

            const data = await res.data
            setLoadingForm(false);
            setiduserCrate(data.data)
            setUsemobileCreate(formdata.userName)
            toast.success(data.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handleClose()
        } catch (error) {
            handelerrors(error)
            setLoadingForm(false)

        }
    }

    const handelUpdataFrom = () => {
        setiduserCrate();
        setUsemobileCreate(formdata.userName);
    }

    const handelSubmit = event => {
        event.preventDefault()
        setLoadingForm(true)
        if (!formdata.referrerId) {
            toast.error(' لطفا معرف  را  انتخاب کنید', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLoadingForm(false)
        }
        else if (!formdata.userName) {
            toast.error(' لطفا نام کاربری را وارد کنید', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLoadingForm(false)
        }
        else if (statuseMobile === true) {
            toast.error(' شماره موبایل وارد شده قبلا ثبت شده است', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLoadingForm(false)
        }
        else if (!formdata.lastName) {
            toast.error(' لطفا نام را وارد کنید', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLoadingForm(false)
        }
        else if (!formdata.firstName) {
            toast.error(' لطفا نام خانوادگی را وارد کنید', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLoadingForm(false)
        }

        else {
            dataUpdate.userName ? handelUpdataFrom() : handelSend()
        }
    }

    const handelmobileNumber = (id) => {
        setiduserCrate(id);
        setUsemobileCreate(formdata.userName);
        handleClose()
    }

    const handelstatusemobile = (status) => setStatuseMobile(status);


    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header >
                <Modal.Title>افزودن مشتری جدید</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Row>
                        <Col lg='6' md='6' sm='12' >
                            <InputControl url='/referrer/dropdown' label='نحوه آشنایی' name='referrerId' handelValue={handelValue} defaultValue={dataUpdate.referrerId} />
                        </Col>
                        <Col lg='6' md='6' sm='12'>
                            <Mobilecheckexist label='شماره موبایل (نام کاربری)' name='userName' handelValue={handelValue} handelstatusemobile={handelstatusemobile} ismodal handelmobileNumber={handelmobileNumber} />
                        </Col>

                        <Col lg='6' md='6' sm='12'>
                            <InputFarsi label='نام' name='firstName' handelValue={handelValue} defaultValue={dataUpdate.lastName} />
                        </Col>
                        <Col lg='6' md='6' sm='12'>
                            <InputFarsi label='نام خانوادگی' name='lastName' handelValue={handelValue} defaultValue={dataUpdate.firstName} />
                        </Col>
                        <Col lg='6' md='6' sm='12'>
                            <InputNumber label='کدملی' name='nationalCode' handelValue={handelValue} maxLength='10' defaultValue={dataUpdate.nationalCode} />
                        </Col>

                        <Col lg='6' md='6' sm='12'>
                            <InputNumber label='شماره  تلفن ثابت' name='tell' handelValue={handelValue} maxLength='8' defaultValue={dataUpdate.tell} />
                        </Col>
                        <Col lg='12' md='12' sm='12' xs='12' >
                            <div className="form-group">
                                <label for="descriptionTextarea">توضیحات</label>
                                <textarea className="form-control" id="descriptionTextarea" rows="6" defaultValue={dataUpdate ? dataUpdate.description : ''} onChange={(e) => handelValue('description', e.target.value)} ></textarea>
                            </div>
                        </Col>
                    </Form.Row>
                    <Form.Row>
                        <Switchrs label='آیا فعال باشد؟' name='isActiveFormUser' handelValue={handelValue} checke={formdata.isActive} />
                    </Form.Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" disabled={LoadingForm} onClick={handleClose}> لغو</Button>

                <button type='submit' className='btn btn-success' onClick={handelSubmit} disabled={LoadingForm} >
                    {LoadingForm ? <i className="fa fa-spinner fa-pulse fa-fw"></i> : dataUpdate.userName ? "ثبت ویرایش" : "ثبت"}
                </button>

            </Modal.Footer>
        </Modal>
    )
}
